module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bloc-global-dates"
  }, [_c('div', {
    staticClass: "col bloc-global-date d-flex flex-column"
  }, [_c('span', {
    class: _vm.isActiveDate(_vm.period.openingDate) ? 'active' : ''
  }, [_vm._v(" " + _vm._s(_vm.getDate(_vm.period.openingDate, "DD/MM")) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.periodOpening")))])]), _vm._v(" "), _c('div', {
    staticClass: "col bloc-global-date d-flex flex-column align-items-center"
  }, [_c('span', {
    class: _vm.isActiveDate(_vm.period.firmorderClosingDate) ? 'active' : ''
  }, [_vm._v("\n            " + _vm._s(_vm.getDate(_vm.period.firmorderClosingDate, "DD/MM")) + "\n        ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.firmOrderClosing")))])]), _vm._v(" "), _c('div', {
    staticClass: "col bloc-global-date d-flex flex-column align-items-end"
  }, [_c('span', {
    class: _vm.isActiveDate(_vm.period.forecastClosingDate) ? 'active' : ''
  }, [_vm._v(" " + _vm._s(_vm.getDate(_vm.period.forecastClosingDate, "DD/MM")) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.forecastExported")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87ae199c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/elements/PeriodDates.vue
// module id = 3304
// module chunks = 0